"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.2384 5.32175C20.613 5.61121 20.682 6.14951 20.3926 6.5241L11.4132 18.1445C10.944 18.7516 10.051 18.8153 9.50037 18.2809L4.54593 13.4722C4.20624 13.1425 4.19814 12.5999 4.52784 12.2602C4.85754 11.9205 5.4002 11.9124 5.73989 12.2421L10.3501 16.7167L19.0361 5.4759C19.3255 5.10132 19.8639 5.0323 20.2384 5.32175Z", fill: "currentColor" }));
